import { useLocation } from './use-location';
import haversine from 'haversine-distance';

interface Location {
  lat: number;
  lon: number;
}

export const useDistance = (targetLocation?: Location | null) => {
  const { coordinates } = useLocation();
  if (!coordinates || !targetLocation) return { distance: undefined };

  return { distance: haversine(coordinates, targetLocation) };
};
